import React, { useState } from 'react';
import { Card, Form, Input, Button, message } from 'antd';
import { UserOutlined, LockOutlined, CarOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import api from '../utils/api';
import { APP_VERSION, APP_BUILD_ID } from '../version';
import SiteFooter from '../components/SiteFooter';

export default function Login() {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const res = await api.post('/auth/login', values);
      const user = res.data.user || {};
      localStorage.setItem('token', res.data.token);
      localStorage.setItem('username', user.username || res.data.username || '');
      localStorage.setItem('name', user.name || user.username || res.data.name || '');
      localStorage.setItem('role', user.role || res.data.role || '');
      localStorage.setItem('city', user.city || '');
      // 登录后从 /me 刷新用户信息和权限
      // 用原生 axios 发，避免触发 api.js 的 401 拦截器清空 localStorage
      try {
        const token = res.data.token;
        const meRes = await axios.get('/api/users/me', {
          headers: { Authorization: `Bearer ${token}` }
        });
        localStorage.setItem('permissions', JSON.stringify(meRes.data.permissions || []));
        if (meRes.data.user_level) {
          localStorage.setItem('user_level', String(meRes.data.user_level));
        }
      } catch (_) {
        // /me 请求失败不影响登录，token 已经存好了
      }
      message.success('登录成功');
      navigate('/');
    } catch (err) {
      message.error(err.response?.data?.detail || '登录失败');
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex', justifyContent: 'center', alignItems: 'center',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      position: 'relative'
    }}>
      <Card style={{ width: 400, borderRadius: 8, boxShadow: '0 8px 24px rgba(0,0,0,0.15)' }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <CarOutlined style={{ fontSize: 48, color: '#667eea' }} />
          <h2 style={{ margin: '12px 0 4px' }}>睿安车辆管理系统</h2>
          <p style={{ color: '#999', margin: 0 }}>请登录您的账号</p>
        </div>
        <Form form={form} onFinish={onFinish} size="large">
          <Form.Item name="username" rules={[{ required: true, message: '请输入用户名' }]}>
            <Input prefix={<UserOutlined />} placeholder="用户名" />
          </Form.Item>
          <Form.Item name="password" rules={[{ required: true, message: '请输入密码' }]}>
            <Input.Password prefix={<LockOutlined />} placeholder="密码" />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading} block style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', border: 'none' }}>
              登 录
            </Button>
          </Form.Item>
        </Form>
        <div style={{ textAlign: 'center', marginTop: 8, color: '#bbb', fontSize: 12 }}>
          版本 v{APP_VERSION}
          {APP_BUILD_ID && APP_BUILD_ID !== 'dev' && (
            <span style={{ marginLeft: 6, opacity: 0.6 }}>#{APP_BUILD_ID}</span>
          )}
        </div>
      </Card>
      {/* 网站备案号（工信部要求在底部展示，需放在登录页可见处） */}
      <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0 }}>
        <SiteFooter />
      </div>
    </div>
  );
}
